import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN

export default {
  getGrouping(season_id: number, queries: any) {
    return Repository.get(`${ADMIN}/season/${season_id}/grouping`, { params: queries })
  },
  getGroupingWhole(season_id: number, queries: any) {
    return Repository.get(`${ADMIN}/season/${season_id}/grouping/whole`, { params: queries })
  },
  postGrouping(season_id: number, data: any) {
    return Repository.post(`${ADMIN}/season/${season_id}/grouping`, data)
  },
  updateGrouping(season_id: number, data: any) {
    return Repository.put(`${ADMIN}/season/${season_id}/grouping`, data)
  },
  updateGroupingPriority(season_id: number, group_id: number, data: any) {
    const dataJson = JSON.stringify(data)
    const config = { headers: {'Content-Type': 'application/json'} }

    return Repository.put(`${ADMIN}/season/${season_id}/grouping/${group_id}/priority`, dataJson, config)
  }
}